import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <div class="wc-box bg-white text-gray-700 shadow-sm rounded p-2 m-2"></div>
`;

export class WCBox extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcBox = clone.content.querySelector('.wc-box');
    let dataNoPadding = this.hasAttribute('data-no-padding');
    if (dataNoPadding) wcBox.classList.remove('p-2');
    if (this.hasAttribute('data-class-bg')) {
      wcBox.classList.remove('bg-white');
      wcBox.classList.add(this.getAttribute('data-class-bg'));
    }
    if (this.hasAttribute('data-class-text')) {
      wcBox.classList.remove('text-gray-700');
      wcBox.classList.add(this.getAttribute('data-class-text'));
    }
    contentNodes.forEach(node => {
      wcBox.append(node);
    });
    // this.innerHTML = '';
    this.replaceWith(wcBox);
  }

}